import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { BodyTextM, BodyTextS } from "@repo/ui";
import { type FC, type ReactElement } from "react";
import { dateTimeFormat } from "../../functions/dates";
import { formatAmount } from "../../utils";

export interface SingleTransactionRowProps {
	icon?: ReactElement;
	title: string;
	date?: Date | string;
	amount: number;
}

const SingleTransactionRow: FC<SingleTransactionRowProps> = ({
	icon,
	title,
	date,
	amount,
}) => {
	return (
		<Stack direction="row" sx={{ alignItems: "center" }} spacing={4}>
			{icon && <Box sx={{ width: 24 }}>{icon}</Box>}
			<Stack sx={{ flexGrow: 1 }}>
				<BodyTextM>{title}</BodyTextM>
				<BodyTextS mb={0} light>
					{date ? dateTimeFormat.format(new Date(date)) : "-"}
				</BodyTextS>
			</Stack>
			<BodyTextM>{formatAmount(amount)}&nbsp;Kč</BodyTextM>
		</Stack>
	);
}

export default SingleTransactionRow;

export const TransactionSkeleton: FC = () => {
	return <Skeleton height={45} variant="rectangular" />;
}
